<div class="w-full p-8 pb-0 flex  justify-end">
    <button (click)="closeDialog()"><i class="fa-light fa-xmark text-3xl text-white"></i></button>
</div>
<div class="flex flex-col items-center justify-center p-4 pb-4">
    <p class="text-white text-xl text-center pb-4 ">Al modificar la URI se modificará para todas las líneas que pertenecen al usuario</p>
    <p class="text-white text-xl pb-8 font-roboto-bold">¿Estś seguro de que quieres hacerlo?</p>
    <div class="flex items-center gap-3">
        <button
            class="rounded-button bg-tertiary w-48 h-13 border border-tertiary cursor-pointer text-white text-lg"
            (click)="closeDialog()">
            Cancelar
        </button>

        <button
            class="rounded-button bg-accent w-48 h-13 border border-tertiary cursor-pointer text-quaternary text-lg"
            (click)="acceptDialog()">
            Aceptar
        </button>
    </div>
</div>
